import _extends from 'babel-runtime/helpers/extends';

import { configSetHeaderModelSortAPI } from '@/api/config';

import { mapGetters } from 'vuex';
import { getMaxIndex } from '@/utils/index';
import Draggable from 'vuedraggable';

export default {
  // 模块管理
  name: 'NavManager',
  components: {
    Draggable: Draggable
  },
  props: {
    collapse: Boolean,
    topModule: Array
  },
  data: function data() {
    return {
      zIndex: getMaxIndex(),
      loading: false,
      isEdit: false,
      topList: [],
      allList: []
    };
  },

  computed: _extends({}, mapGetters(['userInfo', 'bi', 'crm', 'manage', 'oa', 'project', 'headerModule']), {
    containerLeft: function containerLeft() {
      if (this.collapse) {
        return '79px';
      }

      return '215px';
    },
    topModules: function topModules() {
      return this.topList.map(function (item) {
        return item.module;
      });
    },
    allItemsObj: function allItemsObj() {
      var tempsItems = {};
      if (this.crm) {
        tempsItems.crm = {
          title: '客户管理',
          type: 1,
          module: 'crm',
          path: '/crm',
          icon: 'wk wk-customer',
          fontSize: '17px'
        };
      }

      if (this.oa && this.oa.taskExamine) {
        tempsItems.taskExamine = {
          title: '任务/审批',
          type: 4,
          module: 'taskExamine',
          path: '/taskExamine',
          icon: 'wk wk-office',
          fontSize: '16px'
        };
      }

      if (this.oa && this.oa.log) {
        tempsItems.log = {
          title: '日志',
          type: 3,
          module: 'log',
          path: '/workLog',
          icon: 'wk wk-log',
          fontSize: '17px'
        };
      }

      if (this.oa && this.oa.book && this.oa.book.index) {
        tempsItems.book = {
          title: '通讯录',
          type: 6,
          module: 'book',
          path: '/addressBook',
          icon: 'wk wk-address-book',
          fontSize: '17px'
        };
      }

      if (this.project) {
        tempsItems.project = {
          title: '项目管理',
          type: 2,
          module: 'project',
          path: '/project',
          icon: 'wk wk-project',
          fontSize: '15px'
        };
      }

      if (this.bi) {
        tempsItems.bi = {
          title: '商业智能',
          type: 5,
          path: '/bi',
          module: 'bi',
          icon: 'wk wk-business-intelligence',
          fontSize: '18px'
        };
      }

      if (this.oa && this.oa.calendar) {
        tempsItems.calendar = {
          title: '日历',
          type: 8,
          module: 'calendar',
          path: '/calendar/index',
          icon: 'wk wk-calendar',
          fontSize: '20px'
        };
      }
      return tempsItems;
    }
  }),
  watch: {},
  created: function created() {
    var allList = [];
    for (var key in this.allItemsObj) {
      allList.push(this.allItemsObj[key]);
    }
    this.allList = allList;

    this.getHeaderModelSortList();
  },
  mounted: function mounted() {
    // document.body.appendChild(this.$el)
  },
  beforeDestroy: function beforeDestroy() {
    // if (this.appendToBody && this.$el && this.$el.parentNode) {
    //   this.$el.parentNode.removeChild(this.$el)
    // }
  },

  methods: {
    /**
     * 获取置顶应用
     */
    getHeaderModelSortList: function getHeaderModelSortList() {
      if (this.headerModule.length) {
        var allList = [];
        for (var index = 0; index < this.headerModule.length; index++) {
          var key = this.headerModule[index];
          var menu = this.allItemsObj[key];
          if (menu && allList.length < 8) {
            allList.push(menu);
          }
        }
        this.topList = allList;
      } else {
        var _allList = [];
        for (var _key in this.allItemsObj) {
          if (_allList.length < 8) {
            _allList.push(this.allItemsObj[_key]);
          }
        }
        this.topList = _allList;
      }
    },


    /**
     * 保存
     */
    saveClick: function saveClick() {
      var _this = this;

      var keys = this.topList.map(function (item) {
        return item.module;
      });
      this.loading = true;
      configSetHeaderModelSortAPI(keys).then(function (res) {
        _this.isEdit = false;
        _this.$store.dispatch('WKHeaderModule').then(function (res) {
          _this.$message.success('操作成功');
          _this.loading = false;
          _this.$emit('change');
        }).catch(function () {
          _this.loading = false;
        });
      }).catch(function () {
        _this.loading = false;
      });
    },


    /**
     * 判断是否有选择
     */
    isHasSelect: function isHasSelect(module) {
      return this.topModules.includes(module);
    },


    /**
     * 删除
     */
    topModuleDelete: function topModuleDelete(item, index) {
      if (this.topList.length > 1) {
        this.topList.splice(index, 1);
      }
    },


    /**
     * 模块添加
     */
    moduleTopClick: function moduleTopClick(item, index) {
      if (this.topList.length < 8) {
        this.topList.push(item);
      }
    },


    /**
     * 选择模块
     */
    selectClick: function selectClick(item) {
      if (!item.future && !this.isEdit) {
        this.$emit('select', item);
      }
    }
  }
};